// Packages
import axios from 'axios'
import { BehaviorSubject } from 'rxjs'

const currentUserSubject = new BehaviorSubject(JSON.parse(window.localStorage.getItem('E2ICurrentUser') as string))

const login = async (email: string, password: string) => {
	const data = {
		email: email.toLowerCase().trim() || '',
		password: password
	}
	try {
		const res = await axios.post(process.env.REACT_APP_ROUTE_AUTH_LOGIN as string, data)
		if (res.data) {
			const { user, token } = res.data
			if (user && user.id && token) {
				const obj = {
					id: user.id,
					name: user.name
				}
				window.localStorage.setItem('E2ICurrentUser', JSON.stringify(obj))
				window.localStorage.setItem('token', token)
				window.localStorage.setItem('selectedMicrosite', JSON.stringify([]))
				window.localStorage.setItem('selectedVcf', JSON.stringify([]))
				window.localStorage.setItem('selectedKiosk', JSON.stringify([]))
				window.localStorage.setItem('selectedLabel', JSON.stringify([]))
				currentUserSubject.next(user)
				return user
			}
		}
	} catch (err) {
		console.error(err)
	}
}

const logout = () => {
	return axios.post(process.env.REACT_APP_ROUTE_AUTH_LOGOUT as string)
		.then(() => {
			window.localStorage.clear()
			currentUserSubject.next(null)
		})
		.catch((err) => {
			console.error(err)
		})
}

const forgotPassword = (email: string) => {
	const data = {
		email: email.toLowerCase().trim() || ''
	}
	return axios.post(process.env.REACT_APP_ROUTE_AUTH_FORGOTPASSWORD as string, data)
		.then(res => {
			return res.data
		})
		.catch(err => {
			console.error(err)
		})
}

const newUserPassword = (email: string) => {
	const data = {
		email: email.toLowerCase().trim() || '',
		newUserMode: true
	}
	return axios.post(process.env.REACT_APP_ROUTE_AUTH_FORGOTPASSWORD as string, data)
		.then(res => {
			return res.data
		})
		.catch(err => {
			console.error(err)
		})
}

const checkToken = (token: string | undefined) => {
	const data = {
		token: token || ''
	}
	return axios.post(process.env.REACT_APP_ROUTE_AUTH_VALIDATETOKEN as string, data)
		.then(res => {
			return res.data
		})
		.catch(err => {
			console.error(err)
		})
}

const resetPassword = (token: string | undefined, newPassword: string | undefined) => {
	const data = {
		token: token || '',
		newPassword: newPassword || ''
	}
	return axios.post(process.env.REACT_APP_ROUTE_AUTH_RESETPASSWORD as string, data)
		.then(res => {
			return res.data
		})
		.catch(err => {
			console.error(err)
		})
}

const jwtVerifyDecode = (token: string) => {
	const data = {
		token: token || ''
	}
	// axios.post('/api/auth/verifydecode', token)
	return axios.post(process.env.REACT_APP_ROUTE_AUTH_VERIFYDECODE as string, data)
		.then(res => {
			return res.data
		})
		.catch(err => {
			console.error(err)
		})
}
interface settingsProp {
	loggedInUserId: number | string
	name?: string
	contact?: string
	email: string
	password?: string
	newPassword?: string
	confirmPassword?: string
}
const changeSettings = (props: settingsProp) => {
	const obj = {
		name: props.name,
		contact: props.contact,
		email: props.email,
		password: props.password,
		newPassword: props.newPassword,
		confirmPassword: props.confirmPassword
	}
	return axios.put(process.env.REACT_APP_ROUTE_CRUD_PROFILE as string + '/' + props.loggedInUserId, obj)
		.then(result => result.data)
		.catch(error => console.error(error))
}

const verifyEmail = (email: string) => {
	const data = { email }
	return axios.post(process.env.REACT_APP_ROUTE_AUTH_VERIFYEMAIL as string, data)
		.then(res => res.data)
		.catch(err => console.error(err))
}

export default {
	login,
	logout,
	currentUser: currentUserSubject.asObservable(),
	get currentUserValue() { return currentUserSubject.value },
	forgotPassword,
	checkToken,
	resetPassword,
	jwtVerifyDecode,
	changeSettings,
	newUserPassword,
	verifyEmail
}
